// Generated by CoffeeScript 1.11.1
(function() {
  var LayerInfo, UnicodeName,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  module.exports = UnicodeName = (function(superClass) {
    extend(UnicodeName, superClass);

    function UnicodeName() {
      return UnicodeName.__super__.constructor.apply(this, arguments);
    }

    UnicodeName.shouldParse = function(key) {
      return key === 'luni';
    };

    UnicodeName.prototype.parse = function() {
      var pos;
      pos = this.file.tell();
      this.data = this.file.readUnicodeString();
      this.file.seek(pos + this.length);
      return this;
    };

    return UnicodeName;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/unicode_name.js
// module id = 76
// module chunks = 0